import { AsyncReturnType } from "type-fest";

import { ConnectionService } from "@/services";
import { UseMutationSimpleOptions, useMutation } from "@/services/hooks";

type Variables = Parameters<typeof ConnectionService.assignAccount>[0];
type Data = AsyncReturnType<typeof ConnectionService.assignAccount>;
type Error = unknown;

export const useAssignAccount = <TContext = unknown>(
  options?: UseMutationSimpleOptions<Data, Error, Variables, TContext>
) => {
  const result = useMutation<Data, Error, Variables, TContext>(
    ConnectionService.assignAccount,
    options
  );

  return result;
};
